<template>
  <div class="overview-area">
    <el-tabs v-model="activeName">
      <el-tab-pane label="区域经济运行感知预测预警系统" name="7">
        <p>经济金融环境瞬息万变，复杂的宏观局势环境下，地方主政者进行经济管理、政策规划、宏观调控时常常面临诸多痛点，针对这些痛点，腾景潜心积淀三项独家核心能力——AI算法、MDEMS（多维动态均衡矩阵系统）架构、海量数据因子引擎，以解决信息时效性不足、未来趋势预判不清，数据来源不全、分析框架不够科学量化等问题。</p>
        <p>腾景区域经济运行感知预测预警系统在腾景数研学术委员会的指导下设计开发，面向经济运行监测、预测、预警、分析四大场景，依托高频监测、经济预测和投入产出等前沿大数据经济分析模型，为地方政府和企业转型发展的核心需求赋能：</p>
        <p>1.提供对未来经济趋势的科学预判，解决经济数据更新不及时、未来看不清的问题；</p>
        <p>2.评估经济是否处于过冷过热等异常状态，及时提示苗头性、趋势性问题；</p>
        <p>3.全方位评估各行业增长动能，找到促进当地经济增长的重点行业抓手；</p>
        <p>4.各层级区域数据横向全覆盖，纵向全联通，以系统性数据架构支撑全面多维对比分析；</p>
        <p>
          <strong>功能介绍</strong>
        </p>
        <p>
          <strong>（1）经济运行指标监测预测</strong>
        </p>
        <p>团队经过艰苦探索，运用深度学习前沿算法，形成了自主预测模型体系，具备了对经济指标9-12月、准确率70-90%的稳定预测能力，并应用于多种具体场景，可对决策者和管理者关注的区域重点指标（如生产总值、工业增加值、固定资产投资、社会消费品零售总额、公共财政预算收入、地区细分行业等）进行日度模拟和月度预测，按照投资、消费、出口、财政、工业等维度实时监测区域经济指标波动状况，并以集成大屏形式呈现。实现对经济运行更为准确的高频监测和预测。</p>
        <p class="img">
          <img src="../../assets/img/21.png" alt />
        </p>
        <p>
          <strong>（2）产业发展全景分析</strong>
        </p>
        <p>利用腾景大数据和可视化技术，构建产业经济监测分析系统，全景式展现全国/地区众多细分行业的规模与增速，对产业经济全量数据进行关联、汇总，并对全行业进行排名比较，识别经济中的重点行业与高成长行业。并可对各行业关键指标如行业增加值等进行趋势预判。</p>
        <p class="img">
          <img src="../../assets/img/22.png" alt />
        </p>
        <p class="img">
          <img src="../../assets/img/23.png" alt />
        </p>
        <p>
          <strong>（3）增长动能结构分析</strong>
        </p>
        <p>通过对经济中需求侧、供给侧全量数据的结构化分析视角，剖析经济内部结构，识别经济增长中的动能来源，追踪新旧经济动能的切换。例如通过对每月行业增加值的拆解，呈现各行业增速对比以及各行业对GDP的拉动和贡献率大小，挖掘新动能赛道，全方位评估行业对经济的带动作用。再如，总需求“增量”中各部分需求的比重，直观地反映了大家平时很关注的需求增长新动能。</p>
        <p class="img">
          <img src="../../assets/img/24.png" alt />
        </p>
        <p>
          <strong>（4）全面多维对比分析</strong>
        </p>
        <p>针对经济重点指标，关联全国、省市、区县多个行政层级，清晰展现绝对值、增量、增速排名变化，通过跨区域比较，进一步观测经济的运行状态变化。实现各类区域指标的相互关联与跨区对比，支持对于比较方面、数据维度以及时间节点的切换，从而可展示不同方面/不同维度/不同时间的多指标对比与排名，全方位、多层次、多视角地深入了解地区在时代与全国中所处的排名定位。</p>
         <p class="img">
          <img src="../../assets/img/25.png" alt />
        </p>
        <p>
          <strong>（5）风险预警分析</strong>
        </p>
        <p>综合利用扩张收缩景气指数框架、政府发展改革任务框架、阈值分析、对比分析等多种分析框架，基于投资、消费、出口、行业等多维数据指标，对经济运行与产业发展状态进行综合分析，提示过冷过热风险，对经济运行异常状态进行预警，掌握全市产业发展改革任务、指标、成效进度等，便于决策者与管理者及时应对。</p>
        <p>
          <strong>（6）特色数据板块</strong>
        </p>
        <p>特色数据板块囊括了以下两个数据分支：高频大数据和腾景特色指数。</p>
        <p>其中高频大数据综合汇集了互联网大数据、腾景研究院合作伙伴数据（如港口、船舶、航运数据等）、第三方平台数据等多种数据来源，频率主要为日度、周度、旬度等，数据更新快，可及时灵敏地反映经济趋势的变动。</p>
        <p>基于高频大数据可实现对人口、货币等生产要素流动状况的监测，从人、财、物等（如人员流动、存贷款规模、项目投资、重点生活必需品价格等）生产要素的流动特征入手，进一步把握地区经济活力变化。</p>
         <p class="img">
          <img src="../../assets/img/26.png" alt />
        </p>
        <p class="img">
          <img src="../../assets/img/27.png" alt />
        </p>
        <p>定制化指数依托腾景研究院深厚的学术专家资源，形成对于经济社会发展状况的综合全面的评估框架，提炼新一代经济评估模型如高质量发展指数、新发展理念指数等。</p>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "7"
    };
  },
  created() {
    // if (this.$route.query.id) {
    //   this.activeName = this.$route.query.id;
    // }
  }
};
</script>

<style lang="scss" scoped>
.overview-area {
  background: #fff;
  margin: 20px 0 0 20px;
  padding: 20px;
  box-sizing: border-box;
  .title {
    color: #333399;
    text-align: center;
    font-size: 24px;
    padding: 30px 0;
    .big-title {
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 2px;
    }
  }
  p {
    text-indent: 32px;
    img {
      height: 300px;
      padding-bottom: 20px;
    }
    &.img {
      text-align: center;
    }
  }
  /deep/ .el-tabs .el-tabs__item {
    padding-left: 0 !important;
    padding-bottom: 14px !important;
    height: 42px !important;
    font-size: 16px !important;
  }
}
</style>